export var EStepTransitionStatus = /*#__PURE__*/function (EStepTransitionStatus) {
  EStepTransitionStatus["Ready"] = "ready";
  EStepTransitionStatus["Boundary"] = "boundary";
  EStepTransitionStatus["Error"] = "error";
  return EStepTransitionStatus;
}({});